import { IImageHashes } from "../../domain/TenantSlice/IImageHashes";
// Per-image hash modules for Juncos
import hero from "./imgHashes/hero";
import about from "./imgHashes/about";
import blog from "./imgHashes/blog";
import checkout from "./imgHashes/checkout";
import emptyList from "./imgHashes/empty-list";
import events from "./imgHashes/events";
import favicon from "./imgHashes/favicon";
import customerHome from "./imgHashes/customer-home";
import addresses from "./imgHashes/addresses";
import editUser from "./imgHashes/edit-user";
import myOrders from "./imgHashes/my-orders";
import forgotPass from "./imgHashes/forgot-pass";
import logoExpressLarge from "./imgHashes/logo-express-large";
import logoExpress from "./imgHashes/logo-express";
import logoTmFlat from "./imgHashes/logo-tm-flat";
import logoTm from "./imgHashes/logo-tm";
import notFound from "./imgHashes/not-found";
import security from "./imgHashes/security";
import services from "./imgHashes/services";
import privacy from "./imgHashes/privacy";
import unauthorized from "./imgHashes/unauthorized";

// Plain serializable object (no class instance) to satisfy Redux serializable state constraints
export const JuncosImageHashes: IImageHashes = {
    heroImg: hero,
    aboutImg: about,
    blogImg: blog,
    checkoutImg: checkout,
    emptyListImg: emptyList,
    eventsImg: events,
    faviconImg: favicon,
    customerHomeImg: customerHome,
    addressesImg: addresses,
    editUserImg: editUser,
    myOrdersImg: myOrders,
    forgotPassImg: forgotPass,
    logoExpressLargeImg: logoExpressLarge,
    logoExpressJpegImg: logoExpress,
    logoExpressPngImg: logoExpress,
    logoFlatPngImg: logoTmFlat,
    logoJpegImg: logoTm,
    logoPngImg: logoTm,
    notFoundImg: notFound,
    securityImg: security,
    servicesImg: services,
    privacyPolicyImg: privacy,
    unauthorizedImg: unauthorized,
};